import React, {useState} from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import {parse} from 'query-string';

import {usePrevious} from 'front-onceforall-core/dist/utils/customHooks';

import {recordGAEvent} from '../../../../utils/analytics';

import HelpMenuView from './HelpMenuView';

function HelpMenuContainer() {
  const history = useHistory();
  const location = useLocation();
  const prevSearch = usePrevious(location.search);
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [isContactFormOpen, setIsContactFormOpen] = useState(false);

  function handleHelpCenterClick() {
    setIsPanelOpen(true);
    setIsContactFormOpen(false);
    recordGAEvent('HelpCenter', 'Open');
  }

  function handleContactClick() {
    setIsPanelOpen(true);
    setIsContactFormOpen(true);
    recordGAEvent('HelpCenter', 'Contact');
  }

  function handleClosePanel() {
    setIsPanelOpen(false);
    history.push(location.pathname);
  }

  function checkUrl() {
    if (parse(location.search).help !== undefined) {
      handleHelpCenterClick();
      return;
    }

    if (parse(location.search).contact !== undefined) {
      handleContactClick();
      return;
    }

    if (prevSearch && prevSearch.help !== undefined) {
      handleClosePanel();
    }
  }

  React.useEffect(checkUrl, [location.search]);

  return (
    <HelpMenuView
      helpContentId={parse(location.search).help}
      requestType={parse(location.search).contact}
      onHelpCenterClick={handleHelpCenterClick}
      isPanelOpen={isPanelOpen}
      onClosePanel={handleClosePanel}
      isContactFormOpen={isContactFormOpen}
      onContactClick={handleContactClick}
      currentPath={location.pathname}
    />
  );
}

export default HelpMenuContainer;
